import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { CHANGE_EMAIL_INVITATION_PATH } from './constants';
var ChangeEmailInvitationFlow = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/ChangeEmailInvitationFlow');
});
export var changeEmailInvitationRoute = [{
        pathname: CHANGE_EMAIL_INVITATION_PATH,
        component: ChangeEmailInvitationFlow
    }];
